import React, { useCallback, useMemo } from "react";

import useBreakpoint from "hooks/useBreakpoint";
import { devices } from "definitions";
import { YearContainer, YearItem } from "./styles";
import AutoPlayCarousel from "components/AutoPlayCarousel";

const FIRST_EDITION = 2005;

const range = (start, end) => {
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx);
};

export default function YearsCarousel({ yearSelected, onYearSelected }) {
  const { IsLessThan } = useBreakpoint();

  // Se calcula en el render (no en un efecto) para que el carrusel conozca la
  // cantidad de años desde el primer render y pueda posicionarse en el último.
  const years = useMemo(
    () => range(FIRST_EDITION, new Date().getFullYear() - 1),
    []
  );

  const getNumberOfCards = useCallback(() => {
    let cards;

    cards = 6;

    if (IsLessThan(devices.phablet)) {
      cards = 1;
    } else if (IsLessThan(devices.tabletXL)) {
      cards = 3;
    } else if (IsLessThan(devices.laptop)) {
      cards = 4;
    } else if (IsLessThan(devices.wide)) {
      cards = 5;
    }

    return cards;
  }, [IsLessThan]);

  // Es un selector, no una vidriera: sin autoplay, arranca mostrando los últimos
  // años (el carrusel acota el índice para que la última página quede completa).
  return (
    <AutoPlayCarousel
      show={getNumberOfCards()}
      initialIndex={years.length - 1}
      showControls={true}
      autoplay={false}
    >
      {years.map((year) => {
        return (
          <YearContainer key={year}>
            <YearItem
              type="button"
              selected={yearSelected === year}
              aria-pressed={yearSelected === year}
              onClick={() => onYearSelected(year)}
            >
              {year}
            </YearItem>
          </YearContainer>
        );
      })}
    </AutoPlayCarousel>
  );
}
